
































import Vue from 'vue'
import { State } from 'vuex-class'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { createQuoteRequests } from '@/modules/Quote/gql/quote.gql'
import { SnackType } from '@/interfaces/snack'
import { User } from '@/modules/User/interfaces/user'
import { Quote, QuoteRequestCompanyType } from '@/modules/Quote/interfaces/quote'
import RecordTypesHandler from '@/mixins/record-types'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import SearchGeneralAgent from '@/mixins/search-queries/search-ga'
import { showErrors, showNotification } from '@/utils/snack'
import AppTextField from '@/components/AppTextField.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppDialog from '@/components/AppDialog.vue'

interface Company {
  name: string;
  id: number;
  type: QuoteRequestCompanyType;
}

@Component({
  components: {
    AppTextField,
    AppTextSearch,
    AppDialog
  }
})
export default class QuoteRequestMailForm extends mixins(RecordTypesHandler, SearchCarrier, SearchGeneralAgent) {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote

  showDialog = false

  mailFormInput = [
    {
      companyName: '',
      companyId: -1,
      companyType: '',
      email: ''
    }
  ]

  formDialogLoading = false

  candidatesCompany: Company[] = []

  get candidatesCompanyOptions () {
    return this.candidatesCompany.map(com => com.name)
  }

  get mailDialogHeight () {
    const contentHeight = this.mailFormInput.length * 76 + 154

    return contentHeight > 600 ? 600 : contentHeight
  }

  @State(state => state.user.me) me!: User

  @Watch('value')
  async valueChanged (val: boolean) {
    this.showDialog = val
  }

  @Emit('success')
  onSuccess (msg = '') {
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }

  cancelHandler () {
    this.mailFormInput = [
      {
        companyName: '',
        companyId: -1,
        companyType: '',
        email: ''
      }
    ]
    this.hideDialog()
  }

  @Emit('input')
  hideDialog () {
    return false
  }

  addMailInput () {
    this.mailFormInput.push({
      companyName: '',
      companyType: '',
      companyId: -1,
      email: ''
    })
  }

  companySelectedHandler (index: number) {
    const { companyName } = this.mailFormInput[index]

    const company = this.candidatesCompany.find(comp => comp.name === companyName)

    if (!company) {
      this.mailFormInput[index].companyName = ''
      return
    }

    this.mailFormInput[index].companyId = company.id
    this.mailFormInput[index].companyType = company.type
  }

  async getGAAndCarriers (val: string) {
    await Promise.all([
      this.getCandidateGeneralAgents(val),
      this.getCandidateCarriers(val)
    ])

    const { candidatesCarrier, candidatesGeneralAgent } = this

    const carrierCom = candidatesCarrier.map(com => {
      return {
        name: com.name,
        id: com.id,
        type: QuoteRequestCompanyType.CARRIER
      }
    })

    const gaCom = candidatesGeneralAgent.map(com => {
      return {
        name: com.name,
        id: com.id,
        type: QuoteRequestCompanyType.GA
      }
    })

    this.candidatesCompany = [...carrierCom, ...gaCom]
  }

  async confirmMailDialog () {
    const { mailFormInput } = this

    const fillFormValid = (this.$refs.emailform as Vue & { validate: () => boolean }).validate()
    if (!fillFormValid) {
      return
    }

    const inputs = mailFormInput.map(input => {
      return {
        companyId: Number(input.companyId),
        type: input.companyType,
        email: input.email
      }
    })

    try {
      const res = await this.$apollo.mutate({
        mutation: createQuoteRequests,
        variables: {
          quoteId: Number(this.quote.id),
          inputs
        }
      })
      this.cancelHandler()
      this.onSuccess('Create quote requests successfully')
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  @Emit('back')
  backHandler () {
    this.hideDialog()
  }
}
